module.exports = __webpack_public_path__ + "3ef12feaebace077e1cb718331b30245.svg";